export enum TINNotAvailableReason {
    NOT_EMIT_TIN = 'RA',
    OTHER_REASON = 'RB',
    CANNOT_BE_REVEALED = 'RC',
}
